export default __webpack_public_path__ + "static/media/user.0dba7c68.svg";